/**
 * Created by bob.gear on 22/08/2016.
 */
angular.module('EICDataStream3.businessDevelopmentTools', [])
  .controller('WhatIfAnalysisController', ['$scope', '$state', 'whatIfService', 'dialogs',
    function ($scope, $state, whatIfService, dialogs) {
      $scope.componentName = "WhatIfAnalysisController";

      $scope.title = 'What-if Analysis';


      $scope.btnRecalculate = function(){
        $scope.whatIfModel.calculate();
      };

      $scope.data = [
        {
          key: "Cumulative Return",
          values: []
        }];

      $scope.btnComputeScenarioFrequencies = function(){
        for(var block=0; block<100; block++) {
          $scope.whatIfModel.computeScenarioFrequencies();

          var i = 0;
          $scope.data[0].values = []
          Object.keys($scope.whatIfModel.scenarios)
            .forEach(function (scenarioKey) {
              var scenario = $scope.whatIfModel.scenarios[scenarioKey];

              var datum = {};
              datum.label = i++;
              datum.value = scenario.frequency;

              $scope.data[0].values.push(datum);
            });

        }
      };

      $scope.$on('$viewContentLoaded', function(){
        //Here your view content is fully loaded !!
        $scope.whatIfModel = $state.params.whatIfModel;

        // 1.refresh the whatIfModel with data pulled back from the database
        //   a. get a list of projectIDs


        // Strictly, this should follow the patter of creating a resource then fetching it, I suppose.
        // for the sake of demonstration I''m going to hack it and then come up with something better
        // post the model and get back an updated model with projectData
        //   b. do an API call (by  calling the whatIfService
        whatIfService.getProjectData($scope.whatIfModel)
          .then(function(response){
              $scope.whatIfModel.projects.forEach(function(project){
                var matchingProjects = response.data.projects.filter(function(projectData){
                  if (projectData.projectID == project.projectID) return project;
                });


                //   c. merge in the returned data
                if(matchingProjects.length){
                  var projectData = matchingProjects[0];

                  project.projectName = projectData.projectName;
                  project.dollarValue = projectData.dollarValue;
                  project.startupYear = projectData.startupYear;
                  project.country = projectData.country;
                  project.locality = projectData.locality;
                  project.industrySector = projectData.energySector;
                  project.trackingStatus = projectData.trackingStatus;
                  project.operator = projectData.companyName;
                  project.projectStage = projectData.projectStage;
                  project.projectStatus = projectData.projectStatus;

                }
              });


              // 2. recalculate the model
              $scope.whatIfModel.calculate();
           },
          function(e){
            var i=0;
          });
      });



      $scope.options = {
        chart: {
          type: 'discreteBarChart',
          height: 450,
          margin : {
            top: 20,
            right: 20,
            bottom: 50,
            left: 55
          },
          x: function(d){return d.label;},
          y: function(d){return d.value;},
          showValues: true,
          valueFormat: function(d){
            return d3.format(',.4f')(d);
          },
          duration: 500,
          xAxis: {
            axisLabel: 'X Axis'
          },
          yAxis: {
            axisLabel: 'Y Axis',
            axisLabelDistance: -10
          }
        }
      };


    }])

  .controller('WhatIfProjectController', ['$scope', function ($scope) {
    $scope.$watch('project.successProbability', function (newValue, oldValue) {
      if(newValue)
        $scope.project.potentialRevenue = $scope.project.dollarValue * $scope.project.percentageTake;
    });
    $scope.$watch('project.percentageTake', function (newValue, oldValue) {
      if(newValue)
        $scope.project.potentialRevenue = $scope.project.dollarValue * $scope.project.percentageTake;
    });

  }])

  .service("whatIfService", ["$http",
    function($http) {

      this.getProjectData = function(whatIfModel) {
        var projectIDs =  whatIfModel.projects.map(function(project){
          return project.projectID;
        });

        return $http.post("/api/whatIfProjects", {projectIDs:projectIDs} );
      };

    }
  ]);